import * as React from "react";
import WomensMenu from "../../components/pageComponents/Menus/WomensMenu";
import Content from "./Shirts";

export default function WomensContent() {
  return (
    <>
      <WomensMenu />
      <Content />
    </>
  );
}
